import { collection, doc, limit, onSnapshot, orderBy, query } from "firebase/firestore";
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { BiChevronDown } from 'react-icons/bi';
import { FaCheck } from "react-icons/fa6";
import { MdNotificationsActive } from 'react-icons/md';
import { toast } from 'react-toastify';
import {
  Avatar,
  LastMessage,
  Menu,
  Modal,
  ProfileClient,
  ViewerCustomerServiceOpen
} from '../../../../../../../../components';
import { useChat } from '../../../../../../../../contexts/chat';
import { useOutsideAlerter } from '../../../../../../../../hooks';
import { db } from '../../../../../../../../service/serviceChat/chatService';
import { getClients } from '../../../../../../../../service/serviceChat/clientsService';
import { maskDate, NotificationChat, verificationUserExternal } from '../../../../../../../../utils';
import { Container, Content, Date, IconDown, IconNotification, IsSelected, Line, Loading, Name } from './styled';


export function Card(props) {

  const refMenu = useRef();

  const {
    data,
    active,
    onSelectedCustomer,
    selectedCustomer
  } = props;

  const {
    handOpenPreview,
    onTransferCustomerByMy,
    idChat
  } = useChat();

  const [profileOpen, setProfileOpen] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);
  const [notification, setNotification] = useState(null);
  const [name, setName] = useState(data.client_name);
  const [loading, setLoading] = useState(false);
  const [customerServiceOpenData, setCustomerServiceOpenData] = useState(null);
  const [isSelected, setIsSelected] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  useOutsideAlerter(refMenu, handleCloseMenu);

  useEffect(() => {
    if (selectedCustomer?.customerServicersID?.includes(data.id)) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [selectedCustomer, data.id]);


  useEffect(() => {
    if (!data.client_phone) return
    var startNotification = false;
    const q = query(
      collection(doc(db(), "chats_new", data.client_phone), "messages"),
      orderBy("date", "desc"),
      limit(1)
    );
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        if (snapshot.size <= 0) return;
        setNotification({
          docs: snapshot.docs,
          startNotification
        });
        startNotification = true;
      },
      (error) => {
        return unsubscribe();
      }
    );
    return () => {
      unsubscribe();
    }
  }, [data.id]);
  useEffect(() => {
    if (!notification) return;
    const message = notification.docs[0].data();
    setLastMessage(message);
    if (
      (notification.startNotification) &&
      (verificationUserExternal(message)) &&
      (data.client_phone !== idChat)
    ) {
      const notification = new NotificationChat(
        message?.author,
        message?.type === 'text' ? message?.body : 'Nova mensagem',
        data.client_phone
      );
      notification.show();
    }
  }, [notification]);

  async function reloadName() {
    const client = await getClients(data.client_phone);
    setName(client?.name);
  };

  function handleOpenMenu(e) {
    setAnchorEl(e?.currentTarget)
  };

  function handleCloseMenu() {
    setAnchorEl(null);
  };
  function handleOpenProfile() {
    handleCloseMenu();
    setProfileOpen(true);
  };

  function handleCloseProfile() {
    setProfileOpen(false);
  };

  const msgCustomerServiceOpen = (data) => {
    return (
      <div>
        <p>
          {`Já existe atendimento em aberto ! `}
        </p>
        <u
          onClick={
            () => setCustomerServiceOpenData(data)
          }
        >
          {`ver atendimento`}
        </u>
      </div>
    )
  };


  async function handTransferCustomerByMy() {
    setLoading(true);
    const response = await onTransferCustomerByMy(data, false, false);
    if (response === 'error') {
      setLoading(false)
      toast.error('Lamentamos, mas não foi possível iniciar o atendimento.', { position: "top-right", theme: "colored" });
      return
    }
    if (response?.status === 'clone') {
      toast.warn(
        msgCustomerServiceOpen(response?.customerServiceOpen),
        { position: "top-center", theme: "colored" }
      );
      return setLoading(false)
    }
    setLoading(false);
  }
  function handOpenChat(e) {
    if (!selectedCustomer?.isOpen) {
      if (e.shiftKey) {
        return handTransferCustomerByMy();
      }
      handOpenPreview(data, data.client_name, 6);
    }
  };
  const handSelectedCustomer = () => {
    if (selectedCustomer?.isOpen) {
      onSelectedCustomer(data.id);
    }
  };

  return (
    <>
      <Container
        active={active}
        disabled={loading}
        isSelected={isSelected}
        onClick={() => handSelectedCustomer()}
        enabledSelection={selectedCustomer?.isOpen}
      >
        <span className='avatar___'>
          {(isSelected)
            ? <IsSelected>
              <FaCheck fontSize={'2rem'} />
            </IsSelected>
            : <Avatar name={data.client_name} />
          }
        </span>
        <Content>
          <Line onClick={(e) => handOpenChat(e)}>
            <Name>
              <span>{name}</span>
            </Name>
            <Date>
              <span>{maskDate(data.started_at) + ' - ' + moment(data.started_at).format('HH:mm')}</span>
            </Date>
          </Line>
          <Line>
            <div className='lastMessage' onClick={(e) => handOpenChat(e)}>
              {lastMessage ? <LastMessage message={lastMessage} /> : <>...</>}
            </div>
            <div className='icon-line'>
              {verificationUserExternal(lastMessage) &&
                <IconNotification onClick={(e) => handOpenChat(e)}>
                  <MdNotificationsActive />
                </IconNotification>
              }
              <IconDown>
                <BiChevronDown onClick={(e) => handleOpenMenu(e)} />
              </IconDown>
            </div>
          </Line>
        </Content>

        <Menu anchorEl={anchorEl} ref={refMenu}>
          <li onClick={() => handleOpenProfile()}>
            Ver Perfil
          </li>
        </Menu>

      </Container>
      {loading && <Loading />}
      <Modal title={'Atendimento em aberto'}
        isOpen={customerServiceOpenData ? true : false}
        close={
          () => setCustomerServiceOpenData(null)
        }
      >
        <ViewerCustomerServiceOpen
          customerServiceOpen={customerServiceOpenData}
          onClose={
            () => setCustomerServiceOpenData(null)
          }
        />
      </Modal>
      {profileOpen &&
        <ProfileClient
          client={data}
          name={name}
          isOpen={profileOpen}
          close={() => handleCloseProfile()}
          load={reloadName}
        />
      }
    </>
  );
}